import { ListingPageConfig } from '../types/global-settings';

/**
 * Default listing-page section config, applied when the admin has not saved a
 * custom template.
 *
 * Used by the property-page resolver to seed globalService.propertyDetailsConfig,
 * and as the fallback in PropertyDetailsComponent when it is rendered OUTSIDE
 * that resolver — e.g. the favorite/hidden property modal on the account page —
 * where the global config can still be null on a fresh session. Without this
 * fallback the component crashes on `sectionConfig.comment_section` and hides
 * compliance-required sections (MLS disclaimer, listing-firm attribution).
 */
export const DEFAULT_LISTING_PAGE_CONFIG: ListingPageConfig = {
    save_and_view: 'hide',
    similar_homes: 'display',
    related_blogs: 'display',
    related_videos: 'display',
    cities: 'display',
    popular_searches: 'display',
    communities: 'display',
    schools_near: 'display',
    comment_section: 'hide',
    page_sections: [],
    listing_firm_position: 'additional_information',
    mls_disclaimer_position: 'bottom',
    mls_disclaimer_content: '',
};
